import script from "./BaseRibbonRotate.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRibbonRotate.vue?vue&type=script&setup=true&lang=js"

import "./BaseRibbonRotate.vue?vue&type=style&index=0&id=0576141f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0576141f"]])

export default __exports__